import React , { Component } from 'react';
import { ActionIcon } from '@mantine/core';
import { IconCirclePlus } from '@tabler/icons';
import ContainerTranslation from './ContainerTranslation';

class AddButton extends Component{

  render(){

    return (
      <div style={{ display: "flex", alignItems: "center" }}>
        <ActionIcon size={35.66} radius="xl" variant="filled" color="red" aria-label="Settings" style={{ marginRight: "10px" }}>
          <IconCirclePlus style={{ width: "150%", height: "150%", transform: "scale(1.5)" }} stroke={1.5} />
        </ActionIcon>
        <ContainerTranslation id={"nav." + ["Add an other item"]} />
      </div>
    )
  }
}

export default AddButton;
